import { z } from 'zod';

export const DataSchema = z.object({
    status0: z.number().catch(0),
    status1: z.number().catch(0),
    status2: z.number().catch(0),
    status3: z.number().catch(0),
    status4: z.number().catch(0),
    status5: z.number().catch(0),
});
export type DataType = z.infer<typeof DataSchema>;
